import { Juris } from "./Juris";
import Vue from "vue";
Vue.directive('Jurisdiction', {
    inserted(el, binding) {
        // console.log(binding)
        let permission = binding.value;
        if (permission){
            let hasPermission = Juris(permission); 
            if(!hasPermission){
            el.parentNode && el.parentNode.removeChild(el);
            }
        }
    }
})
// v-Jurisdiction="'sys:user:delete'"